import { MAX_CHARACTERS_TO_AUTOSUGGEST } from '#pplx/frontend/apps/ask/suggest-dropdown/primitives/utils/utils.js';
import { isComputerQuerySource } from '#pplx/frontend/stream/types.js';
function isVerticalQuerySource({ querySource, inputLength, }) {
    return (querySource === 'travel' ||
        querySource === 'shopping' ||
        querySource === 'academic' ||
        querySource === 'patents' ||
        querySource === 'sports' ||
        querySource === 'language-learning' ||
        querySource === 'health' ||
        // Computer offers primers only while its input is empty.
        (isComputerQuerySource(querySource) && inputLength === 0));
}
/** Resolves the shared Ask autosuggestion privacy, route, source, and length policy. */
export function resolveSuggestionsDisabled({ autosuggestionsEnabled, hasThreadContent, inputQuery, isCometHomepage, isHomepage, isSuggestionsDisabled, querySource, suggestions, }) {
    return (isSuggestionsDisabled ||
        !autosuggestionsEnabled ||
        // Keep the build check first so sidecar builds can eliminate the route policy.
        (!import.meta.env.VITE_IS_SIDECAR_BUILD &&
            !isHomepage &&
            !isCometHomepage &&
            !isVerticalQuerySource({ querySource, inputLength: inputQuery.length })) ||
        (querySource !== 'finance' &&
            querySource !== 'health' &&
            inputQuery.length > MAX_CHARACTERS_TO_AUTOSUGGEST &&
            !suggestions.some(({ query }) => query === inputQuery)) ||
        (!!import.meta.env.VITE_IS_SIDECAR_BUILD && hasThreadContent));
}
//# sourceMappingURL=resolveSuggestionsDisabled.js.map